import styled from 'styled-components';
import { propsMap } from '@/presentation/interfaces';
import { sizes, weights, letterSpacings, lineHeights } from './Heading.constants';

interface IHeadingProps {
  color?: string;
  size?: 's' | 'm' | 'l';
  weight?: string;
}

const getHeadingTag = (size: string | undefined) => {
  switch (size) {
    case 's':
      return 'h3';
    case 'm':
      return 'h2';
    case 'l':
      return 'h1';
    default:
      return 'h3';
  }
};

const Heading = styled.div.attrs<IHeadingProps>(({ size }) => ({
  as: getHeadingTag(size),
}))<IHeadingProps>`
  color: ${({ color, theme }) => color ?? theme.colors.primaryText};
  font-family: ${({ weight, theme }) => (weight ? (theme.fonts as propsMap)[weight] : theme.fonts.regular)};
  font-size: ${({ size }) => (size ? sizes[size] : sizes.s)};
  font-weight: ${({ weight }) => (weight ? weights[weight] : weights.regular)};
  letter-spacing: ${({ size }) => (size ? letterSpacings[size] : letterSpacings.s)};
  line-height: ${({ size }) => (size ? lineHeights[size] : lineHeights.s)};
  margin: 0;
`;

export default Heading;
